import { fetchData } from '@databases/database-state';
import { Content, RestArray } from '@databases/types/confluence';

import { nextPagination } from '../pagination';

import { rejectOnError } from './utils';

export function getAttachments(
  contentId: string,
  expand: string[] = [],
  firstPage?: RestArray<Content>,
  limit = Infinity
): AsyncGenerator<Content, void, void> {
  return nextPagination(
    async (url) => {
      const res = await fetchData(
        url
          ? url.replace(/([&?]limit=)\d+(&|$)/g, `$1${Math.min(200, limit)}$2`)
          : `/rest/api/content/${encodeURIComponent(
              contentId
            )}/child/attachment?${new URLSearchParams({
              expand: expand.join(','),
              limit: `${Math.min(200, limit)}`,
            })}`
      ).then(rejectOnError);
      return await res.json();
    },
    { firstPage, limit }
  );
}
